import React from 'react';
import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employee',
  'Employment Status',
  'Employment Type',
  'Gender',
  'Location',
  'Manager',
  'Pay Rate',
  'Start Date'
];

const ActiveEmployeesReport = () => {
  return (
    <CompositeReport dateFilter='range' filters={filters}>
      <Report 
        name={t('reports.EMPLOYEES_GOALS_REPORT')}
        url='/reports/employee_goals'
      />
    </CompositeReport>
  );
};

export default ActiveEmployeesReport;

